import { unref, onUnmounted } from 'vue'
import { waitUntil, type WaitUntilReturn } from '@source-digital/experience-utils'
import { MaybeRef } from '@vueuse/core'
import { type default as HlsInstance, type HlsConfig } from 'hls.js'
import { type HlsSourceItem } from '@source-digital/sd-types'

// TODO lazy load hls.js
export default function useHlsSource (
  mediaSource: MaybeRef<HlsSourceItem>,
  htmlVideoEl: MaybeRef<HTMLVideoElement | null>
) {
  let elementWatcher: WaitUntilReturn<HTMLVideoElement>
  let hlsInstance: HlsInstance | undefined
  async function init () {
    if (elementWatcher != null) elementWatcher.cancel()
    elementWatcher = waitUntil(() => unref(htmlVideoEl))
    const videoEl = await elementWatcher.promise
    const { default: Hls } = await import('hls.js')
    if (!Hls.isSupported()) return
    if (hlsInstance != null) {
      hlsInstance.destroy()
    }
    if (unref(mediaSource)?.url == null) return
    const options = unref(mediaSource).options
    const hlsOptions: Partial<HlsConfig> = {}
    if (options?.withCredentials === true) {
      hlsOptions.xhrSetup = (xhr) => { xhr.withCredentials = true }
      // Safari will not send cookies without this
      videoEl.crossOrigin = 'use-credentials'
    }
    hlsInstance = new Hls(hlsOptions)

    hlsInstance.loadSource(unref(mediaSource).url)
    hlsInstance.attachMedia(videoEl)
  }

  onUnmounted(() => {
    if (elementWatcher != null) elementWatcher.cancel()
  })

  return {
    init
  }
}
